export default "__VITE_ASSET__T9P$G3vI__"